import styled from 'styled-components';

import { colors, medias, fonts } from 'assets/styled/tokens';

export const StyledColumnFillFields = styled.div`
  width: 100%;
  height: 100%;
  display: none;

  span {
    position: relative;
    width: 100%;
    max-width: 360px;
    font-weight: 700;
    font-size: 36px;
    line-height: 36px;
    letter-spacing: 0.5px;
    color: ${colors.mediumGray};
    font-family: ${fonts.family.title};
    text-align: center;
  }

  @media screen and (min-width: ${medias.desktopSm}) {
    height: 80%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
  }
`;
